// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressBarAnimated_bar__7Nfl7 {
  display: flex;
  width: 100%;
  height: 8px;
  background: #d8d8ff;
  border-radius: 8px;
  overflow: hidden;
}

.ProgressBarAnimated_progress__5jzXY {
  width: 100%;
  height: 100%;
  background: #000093;
  border-radius: 8px;
  transition: transform 1s;
}
.ProgressBarAnimated_progress__5jzXY.ProgressBarAnimated_failed__m8PAX {
  background: #911727;
}`, "",{"version":3,"sources":["webpack://./src/components/common/ProgressBarAnimate/ProgressBarAnimated.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBCPS;EDQT,kBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,mBCVS;EDWT,kBAAA;EACA,wBAAA;AAGF;AADE;EACE,mBCUM;ADPV","sourcesContent":["@use 'styles/sizes.scss';\n@use 'styles/colors.scss';\n\n\n.bar{\n  display: flex;\n  width: 100%;\n  height: 8px;\n  background: colors.$primary2;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.progress{\n  width: 100%;\n  height: 100%;\n  background: colors.$primary7;\n  border-radius: 8px;\n  transition: transform 1s;\n\n  &.failed{\n    background: colors.$danger6;\n  }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"bar": `ProgressBarAnimated_bar__7Nfl7`,
	"progress": `ProgressBarAnimated_progress__5jzXY`,
	"failed": `ProgressBarAnimated_failed__m8PAX`
};
export default ___CSS_LOADER_EXPORT___;
